import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-purchase-and-expenses',
  templateUrl: './purchase-and-expenses.component.html',
  styleUrls: ['./purchase-and-expenses.component.css']
})
export class PurchaseAndExpensesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
